import React, { useState, useEffect, useCallback } from 'react';
import { Avatar } from '@mui/material';
import { getFirstLetterString } from '../../../utils';

export const AvatarFL = ({
    name,
    onClick = null,
    width = 40,
    height = 40,
    fontSize = 18,
    color = 'var(--primary-light-color)',
}) => {
    const [firstLetter, setFirstLetter] = useState('');

    const getFirstLetter = useCallback(() => {
        const firstLetter = getFirstLetterString(name);
        setFirstLetter(firstLetter);
    }, [name]);

    useEffect(() => {
        getFirstLetter();
    }, []);

    return (
        <>
            <Avatar
                sx={{
                    bgcolor: 'var(--primary-dark-color)',
                    width,
                    height,
                    fontSize,
                }}
                onClick={onClick}
            >
                {firstLetter}
            </Avatar>
        </>
    );
};
